import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetFolderAssetsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  folderId: Types.Scalars['ID']['input'];
  assetType?: Types.InputMaybe<Types.ChildAssetTypeInput>;
  customSort?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  page: Types.PageInput;
  sortBy?: Types.InputMaybe<Array<Types.MetadataSortByInput>>;
}>;


export type GetFolderAssetsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, asset?: { __typename: 'AudioAsset', id: string } | { __typename: 'DocumentAsset', id: string } | { __typename: 'FileAsset', id: string } | { __typename: 'FolderAsset', id: string, assets?: { __typename?: 'FolderAssetsConnection', nodes: Array<{ __typename?: 'CollectionAsset', id?: string | null, index?: number | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | { __typename: 'ImageAsset', id: string } | { __typename: 'InteractiveAsset', id: string } | { __typename: 'InteractiveLiveAsset', id: string } | { __typename: 'ModelAsset', id: string } | { __typename: 'UnsupportedAsset', id: string } | { __typename: 'VersionStackAsset', id: string } | { __typename: 'VideoAsset', id: string } | null } | null };


export const GetFolderAssets = /*#__PURE__*/ gql`
    query GetFolderAssets($accountId: ID!, $folderId: ID!, $assetType: ChildAssetTypeInput, $customSort: Boolean, $page: PageInput!, $sortBy: [MetadataSortByInput!]) {
  account(by: {id: $accountId}) {
    id
    asset(id: $folderId) {
      id
      __typename
      ... on FolderAsset {
        assets(
          assetType: $assetType
          customSort: $customSort
          page: $page
          sortBy: $sortBy
        ) {
          nodes {
            id
            index
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetFolderAssetsQuery, GetFolderAssetsQueryVariables>;

          

          export const useGetFolderAssetsQuery = (options?:QueryHookOptions<GetFolderAssetsQuery, GetFolderAssetsQueryVariables>) => useQuery(GetFolderAssets, options);

          

          export type GetFolderAssetsQueryOptions = QueryHookOptions<GetFolderAssetsQuery, GetFolderAssetsQueryVariables>;

          

          export const useGetFolderAssetsLazyQuery = (options?:LazyQueryHookOptions<GetFolderAssetsQuery, GetFolderAssetsQueryVariables>) => useLazyQuery(GetFolderAssets, options);

          

          export type GetFolderAssetsQueryResult = ReturnType<typeof useGetFolderAssetsQuery>;

          
